<template>
  <div>
    <ib-charts-placeholder v-if="isOtherOverheadEmpty" />
    <el-tabs
      v-else
      v-model="activeTab"
      class="mb-3 tabs"
    >
      <!-- Timeline -->
      <el-tab-pane
        :label="$t('timeline')"
        name="first"
        lazy
      >
        <div class="bg-white pt-4 pb-1">
          <other-overheads-over-time />
        </div>
      </el-tab-pane>
      <!-- /Timeline -->

      <!-- Breakdown -->
      <el-tab-pane
        :label="$t('breakdown')"
        name="second"
        lazy
      >
        <div class="bg-white pt-4 pb-1">
          <distribution-of-other-overheads />
        </div>
      </el-tab-pane>
      <!-- /Breakdown -->

      <!-- Table -->
      <el-tab-pane
        :label="$t('table')"
        name="third"
        lazy
      >
        <div class="bg-white pt-4 pb-2">
          <other-overheads-table />
        </div>
      </el-tab-pane>
      <!-- /Table -->
    </el-tabs>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import DistributionOfOtherOverheads from '@/views/Home/StoryMode/FinancialPlan/Components/Expenses/OtherOverheads/DistributionOfOtherOverheads.vue'
import OtherOverheadsOverTime from '@/views/Home/StoryMode/FinancialPlan/Components/Expenses/OtherOverheads/OtherOverheadsOverTime.vue'
import OtherOverheadsTable from '@/views/Home/StoryMode/Forecast/OtherOverheads/Tables/OtherOverheadTable.vue'

export default {
  name: 'OtherOverheadsTabs',

  components: { OtherOverheadsTable, DistributionOfOtherOverheads, OtherOverheadsOverTime },

  data () {
    return {
      activeTab: 'first'
    }
  },

  computed: {
    ...mapState(['idea']),

    isOtherOverheadEmpty () {
      return this.idea.storyMode.forecast.otherOverheads.otherOverheads.length === 0
    }
  }
}
</script>

<style scoped lang="scss">
.tabs {
  ::v-deep {
    .el-tabs__content {
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-radius: 0 0 8px 8px;
    }
  }
}
</style>
